// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Jhon",
  middleName: "",
  lastName: "Raza",
  message: " Love is the way! ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/JhonRaza",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/jhonraza/",
    },
    {
      image: "fa-instagram",
      url: "https://www.instagram.com/jhonraza/",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/hashirshoaeb.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/profilepic.jpg"),
  imageSize: 375,
  message:
    "Hi! My name is Jhon Raza. I am a Computer Science major from IBA, graduating in 2022. I am a passionate cross-platform (React Native) developer, aspiring software engineer, Actor, and Podcast Host.",
  resume: "https://docs.google.com/document/d/18mE-wP9kPmfcLRn4hmRNeaTyIpamwfLDnIl7wc8g4VA/edit?usp=sharing",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "JhonRaza", //i.e."johnDoe12Gh"
  reposLength: 6,
  specificRepos: [],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    { 
      img: require("../editable-stuff/profilepic.jpg"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/profilepic.jpg"), 
      label: "Second slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Python", value: 90 },
    { name: "HTML/CSS", value: 90 },
    { name: "JavaScript", value: 85 },
    { name: "React Native", value: 80 },
    { name: "Data Structures", value: 75 },
    { name: "SQL", value: 75 },
    { name: "React", value: 70 },
    { name: "PHP", value: 70 },
    { name: "C#", value: 60 },
    { name: "C/C++", value: 60 }
  ],
  softSkills: [
    { name: "Creativity", value: 95 },
    { name: "Public Speaking", value: 90 },
    { name: "Collaboration", value: 90 },    
    { name: "Theater", value: 90 },
    { name: "Empathy", value: 90 },
    { name: "Positivity", value: 85 },
    { name: "Goal-Oriented", value: 80 },
    { name: "Adaptability", value: 80 },
    { name: "Organization", value: 75 },
    { name: "Problem Solving", value: 70 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for full-time App Dev, Software Engineering or Machine Learning opportunities! If you know of any positions available, any questions, or if you just want to say hi, please feel free to email me at",
  email: "jhonraza01@gmail.com",
};

const experiences = {
  show: false,
  heading: "Experience",
  data: [
    {
      role: '',// Here Add Company Name
      companylogo: require('../assets/img/dell.png'),
      date: 'June 2018 – Present',
    },
    {
      role: 'Front-End Developer',
      companylogo: require('../assets/img/boeing.png'),
      date: 'May 2017 – May 2018',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences };
